import React from 'react'
import { Container } from 'react-bootstrap'
import FloatingActionButton from '../Common/FloatingActionButton'

function Footer({ per }) {
  return (
    <Container fluid className='footer__block'>
      <FloatingActionButton per={per}/>
      <div>
      &copy; Team Insights 2025
    </div>
    </Container>
  )
}

export default Footer
